import React from 'react';
import { Link } from 'react-router-dom';

import './styles.scss'
import { useTranslation } from 'react-i18next';


function PageTitle(props) {
    const {title} = props;
    const {t} = useTranslation();

    return (
        <section className="tf-page-title" >    
            <div className="tf-container">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="page-title-heading">{title}</h2>
                        <ul className="breadcrumbs">
                            <li><Link to="/">{t('Home')}</Link></li>
                            <li>{title}</li>
                        </ul> 
                    </div>
                </div>
            </div>                    
        </section>

    );
}

export default PageTitle;